import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography, makeStyles } from '@material-ui/core';

import { colors } from '../../theme/color-palette';
import { BOGLE_MEDIUM } from '../../constants/constant';

const TooltipComponent = ({
	step,
	size,
	index,
	skipProps,
	isLastStep,
	tooltipProps,
	primaryProps,
}) => {
	const classes = useStyles();

	const handleSkip = (e) => {
		sessionStorage.setItem('firstTimeUser', false);
		skipProps?.onClick(e);
	};

	return (
		<div className={classes.container} ref={tooltipProps.ref}>
			{/* Title & content */}
			{step.content}
			{/* Footer */}
			<Box className={classes.footer} data-testid="tooltip-box">
				<Typography
					className={classes.progress}
					data-testid="tooltip-typography">
					{index + 1}/{size}
				</Typography>
				<Box>
					{!isLastStep ? (
						<Button
							disableRipple
							className={classes.skipBtn}
							onClick={(e) => handleSkip(e)}>
							Skip
						</Button>
					) : null}
					<Button
						data-testid="tooltip-button"
						disableRipple
						className={classes.nextBtn}
						onClick={primaryProps.onClick}>
						{isLastStep ? 'Done' : 'Next'}
					</Button>
				</Box>
			</Box>
		</div>
	);
};

const useStyles = makeStyles(() => ({
	container: {
		width: 328,
		maxWidth: '100%',
		borderRadius: 8,
		color: colors.WHITE,
		boxSizing: 'border-box',
		padding: '24px 16px 12px',
		backgroundColor: colors.PURPLE,
	},
	footer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	progress: {
		fontSize: 12,
	},
	nextBtn: {
		fontSize: 14,
		color: colors.PURPLE,
		textTransform: 'none',
		backgroundColor: colors.WHITE,
		'& span': {
			fontFamily: BOGLE_MEDIUM,
		},
		'&:hover': {
			backgroundColor: colors.WHITE,
		},
	},
	skipBtn: {
		fontSize: 14,
		color: colors.WHITE,
		textTransform: 'none',
		fontFamily: BOGLE_MEDIUM,
		'& span': {
			fontFamily: BOGLE_MEDIUM,
		},
	},
}));

TooltipComponent.propTypes = {
	step: PropTypes.number,
	size: PropTypes.number,
	index: PropTypes.number,
	skipProps: PropTypes.object,
	isLastStep: PropTypes.bool,
	tooltipProps: PropTypes.object,
	primaryProps: PropTypes.object,
};

export default TooltipComponent;
